import React, { useEffect, useState } from 'react'
import { DirectionalProps } from '@toasttab/shared/src/components/atoms/Controls/Directional/Directional.d'
import { Controls } from '@toasttab/shared/src/utils/craftUtils'
import classNames from 'classnames'

const Next = ({
  variation = 'primary',
  size = '48',
  classes
}: DirectionalProps) => {
  const colors = Controls.getDirectionalVariationColors(variation)
  const [circleColor, setCircleColor] = useState<string>(colors.circleColor)
  const [pathColor, setPathColor] = useState<string>(colors.pathColor)
  const [circleBackgroundColor, setCircleBackgroundColor] = useState<string>(
    colors.backgroundColor
  )

  useEffect(() => {
    setPathColor(colors.pathColor)
    setCircleColor(colors.circleColor)
    setCircleBackgroundColor(colors.backgroundColor)
  }, [variation, size])

  const svgClasses = classNames(classes, 'rounded-round', {
    'shadow-xl': variation === 'elevated'
  })

  const hoverMouseIn = () => {
    setPathColor(colors.pathColorHover)
    setCircleColor(colors.circleColorHover)
    setCircleBackgroundColor(colors.backgroundColorHover)
  }

  const hoverMouseOut = () => {
    setPathColor(colors.pathColor)
    setCircleColor(colors.circleColor)
    setCircleBackgroundColor(colors.backgroundColor)
  }

  return (
    <svg
      className={`${svgClasses} !w-12 !h-12`}
      data-testid='control-next'
      onMouseEnter={() => hoverMouseIn()}
      onMouseLeave={() => hoverMouseOut()}
      overflow='visible'
      viewBox='0 0 42 42'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='21'
        cy='21'
        data-testid='control-next-circle'
        fill={circleBackgroundColor}
        r='20'
        stroke={circleColor}
        strokeWidth={2}
      />
      <path
        d='M18.3 26l5.7-5-5.7-5'
        data-testid='control-next-path'
        fill='transparent'
        stroke={pathColor}
        strokeWidth={2}
      />
    </svg>
  )
}

export default Next
